export default __webpack_public_path__ + "static/media/ConsolidationandCompaction.2e56a4db.jpg";